import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navigation from "../components/navigation";
import Main from "../pages/main";
import Me from "../pages/me";
import Randomize from "../pages/randomize";

export default function App() {
  return (
    <div className="md:mx-10 lg:mx-24 xl:mx-36">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/me" element={<Me />} />
          <Route path="/randomize" element={<Randomize />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
